// api/branchService.js
import apiClient from '../../../api/apiClient';

export const fetchBranches = async () => {
  try {
    const response = await apiClient.get('/branches');
    return response.data;
  } catch (error) {
    console.error("Error fetching branches:", error);
    throw new Error("Failed to fetch branches");
  }
};

export const createBranch = async (branchData) => {
  try {
    const response = await apiClient.post('/branches', branchData);
    return response.data;
  } catch (error) {
    console.error("Error creating branch:", error);
    throw new Error("Failed to create branch");
  }
};